(() => {
  // 防止重复注入
  if (window.__GM_KeenTrendingInit) return;
  window.__GM_KeenTrendingInit = true;

  const sliders = new WeakMap(); // element -> KeenSlider instance

  // 你可以按主题断点改：<=768 视为 mobile
  const MQ_MOBILE = "(max-width: 768px)";
  const mqlMobile = window.matchMedia(MQ_MOBILE);

  function isMobile() {
    return !!mqlMobile.matches;
  }

  /**
   * section 级别可见性控制：
   * data-visibility="all" | "desktop" | "mobile"
   * - all：两端都初始化
   * - desktop：仅PC初始化
   * - mobile：仅移动端初始化
   */
  function isAllowed(section) {
    const v = (section?.dataset?.visibility || "all").toLowerCase();
    if (v === "all") return true;
    if (v === "desktop") return !isMobile();
    if (v === "mobile") return isMobile();
    return true; // 未知值默认允许
  }

  function toNum(val, fallback) {
    const n = Number(val);
    return Number.isFinite(n) ? n : fallback;
  }

  function buildOptions(el) {
    const loop = el.dataset.loop === "true";
    const au = toNum(el.dataset.au, 0);
    const perDk = toNum(el.dataset.perviewDk, 1);
    const perTb = toNum(el.dataset.perviewTb, perDk);
    const perMb = toNum(el.dataset.perviewMb, 1);
    const space = toNum(el.dataset.space, 0);
    const spaceMb = toNum(el.dataset.spaceMb, space);

    return {
      loop,
      mode: "free",
      slides: { origin: "center", perView: perDk, spacing: space },
      range: { min: -5, max: 5 },
      animation: { duration: au, easing: "ease-out" },
      breakpoints: {
        "(max-width: 1024px)": { slides: { perView: perTb, spacing: space } },
        "(max-width: 768px)": { slides: { perView: perMb, spacing: spaceMb } },
      },
    };
  }

  function ensureDots(section, slider) {
    const dots = section.querySelector(".keen-dots");
    if (!dots) return;

    dots.innerHTML = "";
    const count = slider.track.details.slides.length;

    for (let i = 0; i < count; i++) {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "dot";
      dot.dataset.index = String(i);
      dot.addEventListener("click", () => slider.moveToIdx(i), { passive: true });
      dots.appendChild(dot);
    }

    const update = () => {
      const active = slider.track.details.rel;
      dots.querySelectorAll(".dot").forEach((d, idx) => {
        d.classList.toggle("active", idx === active);
      });
    };

    update();
    slider.on("slideChanged", update);
  }

  function destroyOne(section) {
    const el = section.querySelector("[data-keen]");
    if (!el) return;

    const inst = sliders.get(el);
    if (inst && typeof inst.destroy === "function") {
      inst.destroy();
    }
    sliders.delete(el);

    // 清理状态，让后续端切换可以重新 init
    el.dataset.initialized = "false";
  }

function initOne(section) {
  const el = section.querySelector("[data-keen]");
  if (!el) return;

  // ✅ 当前端不允许显示 → 不初始化（如果之前初始化过，顺便销毁）
  if (!isAllowed(section)) {
    if (el.dataset.initialized === "true") destroyOne(section);
    return;
  }

  // ✅ 只有 0/1 个 slide：不初始化插件（并清理 UI）
  const slidesCount =
    el.querySelectorAll(".keen-slider__slide").length ||
    el.children.length; // 兜底：如果没有 keen-slider__slide class

  if (slidesCount <= 1) {
    if (el.dataset.initialized === "true") destroyOne(section);

    // 可选：隐藏/清空 dots 和左右按钮（避免只有一张还显示控件）
    const dots = section.querySelector(".keen-dots");
    if (dots) dots.innerHTML = "";

    const prev = section.querySelector(".keen-prev, .previous");
    const next = section.querySelector(".keen-next, .next");
    if (prev) prev.style.display = "none";
    if (next) next.style.display = "none";

    el.dataset.initialized = "false";
    return;
  } else {
    // 有多张时确保按钮可见（端切换/动态更新后可能之前被隐藏）
    const prev = section.querySelector(".keen-prev, .previous");
    const next = section.querySelector(".keen-next, .next");
    if (prev) prev.style.display = "";
    if (next) next.style.display = "";
  }

  if (el.dataset.initialized === "true") return;
  if (!window.KeenSlider) return; // keen-slider.min.js 还没加载完

  const slider = new KeenSlider(el, buildOptions(el));
  sliders.set(el, slider);

  // prev/next
  const prev = section.querySelector(".keen-prev, .previous");
  const next = section.querySelector(".keen-next, .next");
  if (prev) prev.addEventListener("click", () => slider.prev(), { passive: true });
  if (next) next.addEventListener("click", () => slider.next(), { passive: true });

  ensureDots(section, slider);

  el.dataset.initialized = "true";
}


  function initAll(root = document) {
    root
      .querySelectorAll(".t4s-trending-slider .t4s-section-inner")
      .forEach(initOne);
  }

  // 1) 首次加载
  const ready = () => initAll();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready, { once: true });
  } else {
    ready();
  }

  // 2) ajax/无刷新加载（MutationObserver）
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches?.(".t4s-trending-slider .t4s-section-inner")) {
          initOne(node);
        } else if (node.querySelector?.(".t4s-trending-slider .t4s-section-inner")) {
          initAll(node);
        }
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // 3) ✅ 端切换/窗口变化：自动按可见性 destroy / init
  // matchMedia 的 change 比 window.resize 更精准
  mqlMobile.addEventListener?.("change", () => {
    initAll(document); // initOne 里会自动 destroy 不该初始化的
  });
})();
